import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from '@heroicons/react/24/outline';

const PricingPlan: React.FC = () => {
  const plans = [
    {
      name: 'SPONSOR ONLY',
      price: 'XX',
      priceLabel: '/sponsor packages vary',
      description: 'Support our tournament while promoting your brand to a wide audience of players and attendees.',
      features: [
        'Multiple sponsorship tiers available',
        'Brand visibility on course signage', 
        'Recognition during event announcements',
        'Networking opportunities',
        'Custom packages available'
      ],
      additionalInfo: '👉 sponsor packages vary',
      featured: false
    },
    {
      name: 'SPONSOR & GOLFER',
      price: '150 + $XX',
      priceLabel: '/sponsor packages vary',
      description: 'Play in the tournament while promoting your business to all participants and attendees.',
      features: [
        '18-hole scramble entry included',
        'Sponsorship exposure on course & event materials',
        'Logo placement & recognition',
        'Player perks, food & refreshments',
        'Tiered sponsorship upgrades available'
      ],
      additionalInfo: '👉 $150 + sponsor packages',
      featured: true
    },
    {
      name: 'À LA CARTE',
      price: 'Donations Vary',
      priceLabel: '/selection',
      description: 'Choose from various options to participate in our tournament and support our cause.',
      features: [
        'Add a Golfer',
        'Dinner Only',
        'Silent Auction Donation',
        'Monetary Donation'
      ],
      additionalInfo: '👉 donations vary on selection',
      featured: false
    }
  ];

  return (
    <section id="registration" className="pricing-plan py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
          {/* Left Side - Title */}
          <div>
            <div className="flex items-center mb-6">
              <span className="text-sm font-semibold text-gray-600 uppercase tracking-wider">
                REGISTRATION
              </span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              Champions Classic 2026 Registration Fees
            </h2>
          </div>
          
          {/* Right Side - Description */}
          <div className="flex items-center">
            <div className="text-gray-600 text-lg leading-relaxed">
              <p className="font-bold mb-3">
                Join Crash Champions for a day of golf, connection, and community impact.
              </p>
              <p>
                Whether you're playing, sponsoring, or both, our tournament provides valuable exposure, memorable experiences, and opportunities to support a great cause.
              </p>
            </div>
          </div>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div
              key={plan.name}
              className={`rounded-3xl p-8 relative pricing-card ${
                plan.featured 
                  ? 'bg-black text-white pricing-card-featured' 
                  : 'bg-white border border-gray-200'
              }`}
            >
              {/* Plan Name */}
              <h3 className={`text-3xl font-bold mb-4 ${
                plan.featured ? 'text-white' : 'text-gray-900'
              }`}>
                {plan.name}
              </h3>

              {/* Description */}
              <p className={`text-sm mb-6 leading-relaxed ${
                plan.featured ? 'text-gray-300' : 'text-gray-600'
              }`}>
                {plan.description}
              </p>



              {/* Features */}
              <div className={`space-y-4 mb-8 p-6 rounded-2xl ${
                plan.featured 
                  ? 'bg-gray-800' 
                  : 'bg-gray-50'
              }`}>
                {plan.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center">
                    <div 
                      className="w-5 h-5 rounded-full flex items-center justify-center mr-3 flex-shrink-0"
                      style={{ backgroundColor: '#e51c22' }}
                    >
                      <CheckIcon className="w-3 h-3 text-white" strokeWidth={3} />
                    </div>
                    <span className={`text-sm ${
                      plan.featured ? 'text-gray-300' : 'text-gray-600'
                    }`}>
                      {feature}
                    </span>
                  </div>
                ))}
              </div>

              {/* Additional Info */}
              {plan.additionalInfo && (
                <div className="mb-6">
                  <p className={`text-sm font-medium ${
                    plan.featured ? 'text-gray-300' : 'text-gray-700'
                  }`}>
                    <span style={{ color: '#e51c22' }}>👉</span> {plan.additionalInfo.replace('👉 ', '')}
                  </p>
                </div>
              )}

              {/* Get Started Button */}
              <Link
                to="/register"
                state={{ 
                  selectedPlan: plan.name,
                  price: plan.price,
                  planType: plan.name === 'SPONSOR ONLY' 
                    ? 'sponsor' 
                    : plan.name === 'SPONSOR & GOLFER'
                    ? 'sponsor-golfer'
                    : plan.name === 'À LA CARTE'
                    ? 'al-a-carte'
                    : plan.name.toLowerCase().replace(/ & /g, '-').replace(/ /g, '-')
                }}
                className="w-full py-4 px-6 rounded-full font-bold text-sm transition-all duration-300 flex items-center justify-center"
                style={{
                  backgroundColor: '#e51c22',
                  color: '#fff'
}}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c41e3a'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e51c22'}
              >
                Get Started
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingPlan;